import Platforms from '@Config/platforms';
import Devices from '@Config/devices';
import isMobile from '@Utils/Device/IsMobile';

class Config {

    public static FACEBOOK_URL = 'https://fb.gg/play/freeriderjumps';

    public static WIDTH = 1000;

    public static HEIGHT = 562;

    public static ENVIRONMENT = process.env.NODE_ENV;

    public static NETWORK = process.env.FRJ_NETWORK;

    public static RESOLUTION = window.devicePixelRatio;

    public static DEVICE = isMobile() ? Devices.MOBILE : Devices.DESKTOP;

    public static PLATFORM = Platforms.WEB;

    public static SECTOR_SIZE = 100;
}


export default Config;